import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-ungroup-confirm',
    templateUrl: './ungroup-confirm.component.html',
    styleUrls: ['./ungroup-confirm.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class UngroupConfirmComponent {

  occurances: number;

  constructor(
    public dialogRef: MatDialogRef<UngroupConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) detailsData
    ) { 
      this.occurances = detailsData.occurances;
    }

  onClick(value:boolean) {
    this.dialogRef.close(value);
  }

}
